import request from '@/utils/request'

export default {
  getAutoComplete (params, cancelToken, isSuper) {
    return request({
      url: `autoComplete`,
      cancelToken: cancelToken.token,
      method: 'get',
      params: {
        query: params
      }
    })
  },
  getAutoCompleteV3 (params, cancelToken, isSuper) {
    return request({
      url: isSuper ? `${process.env.VUE_APP_API}/v3/autoCompleteForTest` : `${process.env.VUE_APP_API}/v3/web/autoComplete`,
      cancelToken: cancelToken.token,
      method: 'get',
      params: {
        query: params.query,
        first: params.first
      }
    })
  },
  getAutoCompleteByType (params) {
    const { query, type, page, pageSize } = params
    return request({
      url: `${process.env.VUE_APP_API}/v3/autoComplete/${type}`,
      method: 'get',
      params: {
        query,
        page,
        pageSize
      }
    })
  },
  getItemByAutoCompleteId (autoCompleteId) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/reverseLookup/${autoCompleteId}`,
      method: 'get'
    })
  },
  getFilterOptions (currency = '') {
    return request({
      url: `hotels/filters`,
      methods: 'get',
      params: {
        ...currency
      }
    })
  }
}
